import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  UserCog, 
  UserCheck, 
  ClipboardList, 
  Wrench, 
  FileText, 
  LifeBuoy, 
  ShieldAlert,
  ChevronRight,
  AlertTriangle
} from "lucide-react";

const AdminBar = ({ sidebarOpen, setSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const adminMenu = [
    { key: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/admin-dashboard" },
    { key: "clients", label: "Clientes", icon: Users, path: "/admin-clients" },
    { key: "tecs", label: "Técnicos", icon: UserCog, path: "/admin-tecs" },
    { key: "approve-tecs", label: "Aprovar Técnicos", icon: UserCheck, path: "/admin-act-tecs" },
    { key: "orders", label: "Ordens de Serviço", icon: ClipboardList, path: "/admin-orders" },
    { key: "functions", label: "Funções", icon: Wrench, path: "/admin-functions" },
    { key: "suspects", label: "Suspeitas de Fraude", icon: AlertTriangle, path: "/admin-suspects" },
    { key: "logs", label: "Logs do Sistema", icon: FileText, path: "/admin-logs" },
    { key: "support", label: "Suporte", icon: LifeBuoy, path: "/admin-support" },
  ];

  const handleNavigate = (path) => {
    navigate(path);
    if (setSidebarOpen) setSidebarOpen(false);
  };

  return (
    <>
      {/* Overlay Mobile */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-40 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      <aside className={`fixed lg:sticky top-[73px] left-0 z-40 h-[calc(100vh-73px)] w-[280px] bg-white border-r border-slate-200 transform transition-transform duration-300 ${sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="h-full flex flex-col p-6 text-left">
          <div className="mb-8">
            <h2 className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] mb-1">Painel de Gestão</h2>
            <div className="h-1 w-12 bg-slate-900 rounded-full"></div>
          </div>

          <nav className="flex-1 space-y-1">
            {adminMenu.map((item) => {
              const Icon = item.icon;
              const isActive = currentPath === item.path;
              return (
                <button
                  key={item.key}
                  onClick={() => handleNavigate(item.path)}
                  className={`w-full flex items-center justify-between gap-3 px-4 py-3.5 rounded-2xl text-sm font-bold transition-all uppercase italic tracking-tighter ${isActive ? "bg-slate-900 text-white shadow-lg shadow-slate-200" : "text-slate-500 hover:bg-slate-50"}`}
                >
                  <div className="flex items-center gap-3 text-left">
                    <Icon size={18} className={isActive ? "text-orange-500" : "text-slate-400"} />
                    <span>{item.label}</span>
                  </div>
                  {isActive && <ChevronRight size={14} className="text-orange-500" />}
                </button>
              );
            })}
          </nav>

          <div className="mt-auto p-5 bg-slate-900 rounded-[2rem] text-white relative overflow-hidden group">
              <ShieldAlert className="text-orange-500 mb-2" size={20} />
              <p className="text-[10px] font-black uppercase tracking-widest leading-tight">Admin Principal</p>
              <div className="absolute right-[-10px] bottom-[-10px] opacity-10 group-hover:scale-110 transition-transform">
                <LayoutDashboard size={80} />
              </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default AdminBar;